const AGENT_TASKS_QUERY = `
  query AgentTasks($limit: Int, $offset: Int) {
    agentTasks(limit: $limit, offset: $offset) {
      id
      title
      requestText
      taskKind
      triggerKind
      status
      deliveryChannels
      entityLabels
      marketDecisionId
      marketDecisionTitle
      latestStatusSummary
      lastFailureCode
      lastRunStatus
      lastRunAt
      nextRunAt
      pausedAt
      canceledAt
      completedAt
      createdAt
      updatedAt
    }
  }
`;

const AGENT_TASK_ACTION_MUTATION = `
  mutation AgentTaskAction($id: ID!, $action: String!) {
    agentTaskAction(id: $id, action: $action) {
      status
      error
      task {
        id
        status
        nextRunAt
        lastRunStatus
        lastFailureCode
        lastRunAt
        latestStatusSummary
        updatedAt
      }
    }
  }
`;

export const AGENT_TASKS_UPDATED_EVENT = "incite:agent-tasks-updated";

const requestGraphql = async (query, variables) => {
  const response = await fetch("/graphql", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ query, variables }),
  });
  const data = await response.json();
  if (data.errors?.[0]) {
    throw new Error(data.errors[0].message || "Agent task request failed");
  }
  return data.data;
};

export const getAgentTasks = async ({ limit = 25, offset = 0 } = {}) => {
  const data = await requestGraphql(AGENT_TASKS_QUERY, { limit, offset });
  return data?.agentTasks || [];
};

export const runAgentTaskAction = async ({ id, action }) => {
  const data = await requestGraphql(AGENT_TASK_ACTION_MUTATION, { id, action });
  const payload = data?.agentTaskAction;
  if (!payload || payload.status !== "200") {
    throw new Error(payload?.error || "Agent task action failed");
  }
  return payload.task;
};

export const notifyAgentTasksUpdated = (detail = {}) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(AGENT_TASKS_UPDATED_EVENT, { detail }),
  );
};
